import React from 'react';
import { FadeIn } from './FadeIn';
import { Calendar, Clock } from 'lucide-react';
export function ClassSchedule() {
  const scheduleData = [{
    time: '06:00 AM - 07:00 AM',
    type: 'Morning Batch',
    classes: [{
      day: 'Mon',
      name: 'Hatha Yoga',
      color: 'bg-blue-100 text-blue-800'
    }, {
      day: 'Tue',
      name: 'Power Yoga',
      color: 'bg-orange-100 text-orange-800'
    }, {
      day: 'Wed',
      name: 'Hatha Yoga',
      color: 'bg-blue-100 text-blue-800'
    }, {
      day: 'Thu',
      name: 'Power Yoga',
      color: 'bg-orange-100 text-orange-800'
    }, {
      day: 'Fri',
      name: 'Meditation',
      color: 'bg-purple-100 text-purple-800'
    }, {
      day: 'Sat',
      name: 'Special Flow',
      color: 'bg-green-100 text-green-800'
    }]
  }, {
    time: '07:00 AM - 08:00 AM',
    type: 'Morning Batch',
    classes: [{
      day: 'Mon',
      name: 'Power Yoga',
      color: 'bg-orange-100 text-orange-800'
    }, {
      day: 'Tue',
      name: 'Hatha Yoga',
      color: 'bg-blue-100 text-blue-800'
    }, {
      day: 'Wed',
      name: 'Power Yoga',
      color: 'bg-orange-100 text-orange-800'
    }, {
      day: 'Thu',
      name: 'Hatha Yoga',
      color: 'bg-blue-100 text-blue-800'
    }, {
      day: 'Fri',
      name: 'Core Flow',
      color: 'bg-red-100 text-red-800'
    }, {
      day: 'Sat',
      name: 'Meditation',
      color: 'bg-purple-100 text-purple-800'
    }]
  }, {
    time: '05:00 PM - 06:00 PM',
    type: 'Evening Batch',
    classes: [{
      day: 'Mon',
      name: 'Hatha Yoga',
      color: 'bg-blue-100 text-blue-800'
    }, {
      day: 'Tue',
      name: 'Weight Loss',
      color: 'bg-pink-100 text-pink-800'
    }, {
      day: 'Wed',
      name: 'Hatha Yoga',
      color: 'bg-blue-100 text-blue-800'
    }, {
      day: 'Thu',
      name: 'Weight Loss',
      color: 'bg-pink-100 text-pink-800'
    }, {
      day: 'Fri',
      name: 'Restorative',
      color: 'bg-teal-100 text-teal-800'
    }, {
      day: 'Sat',
      name: 'Closed',
      color: 'bg-gray-100 text-gray-500'
    }]
  }, {
    time: '06:00 PM - 07:00 PM',
    type: 'Evening Batch',
    classes: [{
      day: 'Mon',
      name: 'Power Yoga',
      color: 'bg-orange-100 text-orange-800'
    }, {
      day: 'Tue',
      name: 'Hatha Yoga',
      color: 'bg-blue-100 text-blue-800'
    }, {
      day: 'Wed',
      name: 'Power Yoga',
      color: 'bg-orange-100 text-orange-800'
    }, {
      day: 'Thu',
      name: 'Hatha Yoga',
      color: 'bg-blue-100 text-blue-800'
    }, {
      day: 'Fri',
      name: 'Meditation',
      color: 'bg-purple-100 text-purple-800'
    }, {
      day: 'Sat',
      name: 'Closed',
      color: 'bg-gray-100 text-gray-500'
    }]
  }];
  const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  return <section id="schedule" className="py-24 bg-yoga-warm" data-id="element-56">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-57">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-58">
          <FadeIn data-id="element-59">
            <span className="text-yoga-primary font-bold uppercase tracking-wider text-sm block mb-2" data-id="element-60">
              Class Schedule
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-yoga-dark mb-6" data-id="element-61">
              Find the perfect time to practice
            </h2>
            <p className="text-lg text-yoga-muted" data-id="element-62">
              We offer multiple batches throughout the day to accommodate your
              routine. Sunday is our day of rest.
            </p>
          </FadeIn>
        </div>

        {/* Desktop Table View */}
        <FadeIn delay={200} data-id="element-63">
          <div className="hidden lg:block bg-white rounded-2xl shadow-sm overflow-hidden border border-gray-100" data-id="element-64">
            <table className="w-full text-left border-collapse" data-id="element-65">
              <thead data-id="element-66">
                <tr className="bg-yoga-dark text-white" data-id="element-67">
                  <th className="py-5 px-6 font-bold w-1/4" data-id="element-68">
                    <div className="flex items-center gap-2" data-id="element-69">
                      <Clock className="w-5 h-5" data-id="element-70" /> Time
                    </div>
                  </th>
                  {days.map(day => <th key={day} className="py-5 px-4 font-bold text-center border-l border-white/10" data-id="element-71">
                      {day}
                    </th>)}
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100" data-id="element-72">
                {scheduleData.map((row, idx) => <tr key={idx} className="hover:bg-gray-50 transition-colors" data-id="element-73">
                    <td className="py-6 px-6 border-r border-gray-100" data-id="element-74">
                      <div className="font-bold text-yoga-dark" data-id="element-75">{row.time}</div>
                      <div className="text-sm text-yoga-muted mt-1" data-id="element-76">
                        {row.type}
                      </div>
                    </td>
                    {row.classes.map((cls, cIdx) => <td key={cIdx} className="py-4 px-2 text-center border-r border-gray-100 last:border-0" data-id="element-77">
                        <span className={`inline-block px-3 py-1.5 rounded-md text-sm font-medium w-full ${cls.color}`} data-id="element-78">
                          {cls.name}
                        </span>
                      </td>)}
                  </tr>)}
              </tbody>
            </table>
          </div>
        </FadeIn>

        {/* Mobile/Tablet Card View */}
        <div className="lg:hidden space-y-8" data-id="element-79">
          {scheduleData.map((row, idx) => <FadeIn key={idx} delay={idx * 100} data-id="element-80">
              <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-81">
                <div className="bg-yoga-dark text-white p-4 flex justify-between items-center" data-id="element-82">
                  <div className="font-bold flex items-center gap-2" data-id="element-83">
                    <Clock className="w-4 h-4" data-id="element-84" /> {row.time}
                  </div>
                  <div className="text-sm bg-white/20 px-2 py-1 rounded" data-id="element-85">
                    {row.type}
                  </div>
                </div>
                <div className="p-4 grid grid-cols-2 sm:grid-cols-3 gap-3" data-id="element-86">
                  {row.classes.map((cls, cIdx) => <div key={cIdx} className="flex flex-col" data-id="element-87">
                      <span className="text-xs text-yoga-muted mb-1 font-bold" data-id="element-88">
                        {cls.day}
                      </span>
                      <span className={`px-2 py-2 rounded-md text-xs font-medium text-center ${cls.color}`} data-id="element-89">
                        {cls.name}
                      </span>
                    </div>)}
                </div>
              </div>
            </FadeIn>)}
        </div>

        <div className="mt-12 text-center" data-id="element-90">
          <FadeIn delay={400} data-id="element-91">
            <a href="#contact" className="inline-flex items-center justify-center px-8 py-4 bg-yoga-primary text-white font-bold rounded-full hover:bg-yoga-light transition-colors shadow-lg hover:shadow-yoga-primary/30 gap-2" data-id="element-92">
              <Calendar className="w-5 h-5" data-id="element-93" /> Book a trial class
            </a>
            <p className="text-sm text-yoga-muted mt-4" data-id="element-94">
              Prior booking is recommended as batch sizes are limited.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}